module.exports = __webpack_public_path__ + "img/home-footer.607b4251.jpg";